import { render } from "./2022-10-18-UA.md?vue&type=template&id=683b23af"
import script from "./2022-10-18-UA.md?vue&type=script&lang=js"
export * from "./2022-10-18-UA.md?vue&type=script&lang=js"
script.render = render

export default script